/** Rota da LP pública do programa Indique e Ganhe. */
export const REFERRAL_LANDING_PATH = "/indique-e-ganhe" as const

export function isReferralLandingPath(pathname: string | null | undefined): boolean {
  return pathname === REFERRAL_LANDING_PATH
}
